import { fromSpecific, lazy } from '@rehaje/core'
import { reactive } from '@rehaje/reactive'

import { ValuableNode } from '../../models'

import type { SchemaNode } from '../../models'
import type { TypedNode } from '@rehaje/core'

export class SchemaArrayNode extends ValuableNode {
  @fromSpecific()
  @reactive('shallow')
  additionalItems?: SchemaNode

  @fromSpecific()
  @lazy()
  @reactive('shallow')
  items?: SchemaNode | SchemaNode[]

  @fromSpecific()
  @reactive()
  maxItems?: number

  @fromSpecific()
  @reactive()
  minItems?: number

  override evaluateTraverse(visitor: (node: TypedNode) => boolean | void) {
    if (visitor(this) === false) return
  }
}

declare global {
  export interface RehajeTypedNodes {
    'Schema.Array': SchemaArrayNode
  }
}
